const PROD_BILLETTERIE_URL = 'https://buy.eventsbilletterie.com';

function isLocalDevHost(hostname) {
    return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
}

/**
 * URL de base du site Laravel (buy-eventsbilletterie).
 * Définir REACT_APP_BILLETTERIE_URL dans .env (ex. http://127.0.0.1:8000), puis redémarrer `npm start`.
 */
export function getBilletterieBaseUrl() {
    const fromEnv = (process.env.REACT_APP_BILLETTERIE_URL || '').trim().replace(/\/$/, '');
    if (fromEnv && /^https?:\/\//i.test(fromEnv)) {
        return fromEnv;
    }

    if (typeof window !== 'undefined' && isLocalDevHost(window.location.hostname)) {
        return 'http://127.0.0.1:8000';
    }

    return PROD_BILLETTERIE_URL;
}

/** Lien réservation Laravel : {base}/events/{uuid}/paiement */
export function buildEventBookingUrl(eventOrId) {
    const id = typeof eventOrId === 'string' ? eventOrId : eventOrId?.id;
    if (!id) {
        return '';
    }

    const base = getBilletterieBaseUrl();
    return `${base}/events/${id}/paiement`;
}
